<template>
    <v-dialog
        :value="isOpen"
        max-width="900px"
        transition="slide-y-transition"
        origin="top center"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    <template v-if="!isEditable || showOnly">
                        Szczegóły adresu
                    </template>
                    <template v-else>
                        <template v-if="action == 'create'">
                            Dodaj adres
                        </template>
                        <template v-else>
                            Edycja adresu
                        </template>
                    </template>
                </h1>
            </v-card-title>
            <v-card-text>
                <v-col cols="12">
                    <v-expansion-panels
                        accordion
                        multiple
                    >
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                <v-row no-gutters align="center" dense>
                                    <v-col cols="auto">
                                        <span>
                                            <h1 class="text-subtitle-1">
                                                <template>
                                                    Dostawca
                                                </template>
                                            </h1>
                                        </span>
                                    </v-col>
                                </v-row>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <div class="mx-5 my-1">
                                    <v-row>
                                        <v-col cols="12">
                                            <v-select
                                                v-model="senderAddress"
                                                :items="senderAddresses"
                                                label="Wybierz z dostępnych adresów"
                                                return-object
                                                item-text="companyName"
                                                outlined
                                                dense
                                                hide-details
                                                no-data-text="Brak adresów"
                                                class="mb-6"
                                                clearable
                                                :disabled="!isEditable || showOnly"
                                                @input="changeSenderAddress"
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <v-text-field
                                                v-model="shippingLabelAddress.senderCompanyName"
                                                label="Nazwa firmy"
                                                outlined
                                                dense
                                                :disabled="!isEditable || showOnly"
                                                :error-messages="senderCompanyNameErrors"
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-text-field
                                                v-model="shippingLabelAddress.senderFirstName"
                                                label="Imię"
                                                outlined
                                                dense
                                                :disabled="!isEditable || showOnly"
                                            />
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field
                                                v-model="shippingLabelAddress.senderLastName"
                                                label="Nazwisko"
                                                outlined
                                                dense
                                                :disabled="!isEditable || showOnly"
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-text-field
                                                v-model="shippingLabelAddress.senderStreet"
                                                :error-messages="senderStreetErrors"
                                                label="Ulica"
                                                outlined
                                                dense
                                                :disabled="!isEditable || showOnly"
                                            />
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field
                                                v-model="shippingLabelAddress.senderZipCode"
                                                :error-messages="senderZipCodeErrors"
                                                label="Kod pocztowy"
                                                outlined
                                                dense
                                                :disabled="!isEditable || showOnly"
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-text-field
                                                v-model="shippingLabelAddress.senderCity"
                                                :error-messages="senderCityErrors"
                                                label="Miasto"
                                                outlined
                                                dense
                                                :disabled="!isEditable || showOnly"
                                            />
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-select
                                                v-model="shippingLabelAddress.senderCountryId"
                                                :items="countries"
                                                item-value="id"
                                                item-text="name"
                                                no-data-text="Nie znaleziono kraju"
                                                label="Kraj"
                                                outlined
                                                dense
                                                :disabled="!isEditable || showOnly"
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="4">
                                            <v-text-field
                                                v-model="shippingLabelAddress.senderPhoneNumber"
                                                v-mask="'(+##) #########'"
                                                label="Telefon"
                                                outlined
                                                dense
                                                :disabled="!isEditable || showOnly"
                                            />
                                        </v-col>
                                    </v-row>
                                </div>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                <v-row no-gutters align="center" dense>
                                    <v-col cols="auto">
                                        <span>
                                            <h1 class="text-subtitle-1">
                                                <template>
                                                    Odbiorca
                                                </template>
                                            </h1>
                                        </span>
                                    </v-col>
                                </v-row>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <div class="mx-5 my-1">
                                    <v-row>
                                        <v-col cols="12">
                                            <v-select
                                                v-model="customerAddress"
                                                :items="customerPredictAddress"
                                                label="Wybierz z dostępnych adresów"
                                                return-object
                                                item-text="companyName"
                                                outlined
                                                dense
                                                hide-details
                                                no-data-text="Brak adresów"
                                                class="mb-6"
                                                clearable
                                                :disabled="!isEditable || showOnly"
                                                @input="changeAddress"
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <v-text-field
                                                v-model="shippingLabelAddress.companyName"
                                                :error-messages="companyNameErrors"
                                                label="Nazwa firmy"
                                                outlined
                                                dense
                                                :disabled="!isEditable || showOnly"
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col>
                                            <v-text-field
                                                v-model="shippingLabelAddress.contactPerson"
                                                :error-messages="contactPersonErrors"
                                                label="Osoba kontaktowa"
                                                outlined
                                                dense
                                                :disabled="!isEditable || showOnly"
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-text-field
                                                v-model="shippingLabelAddress.street"
                                                :error-messages="streetErrors"
                                                label="Ulica"
                                                outlined
                                                dense
                                                :disabled="!isEditable || showOnly"
                                            />
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-text-field
                                                v-model="shippingLabelAddress.postCode"
                                                :error-messages="postCodeErrors"
                                                label="Kod pocztowy"
                                                outlined
                                                dense
                                                :disabled="!isEditable || showOnly"
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="6">
                                            <v-text-field
                                                v-model="shippingLabelAddress.city"
                                                :error-messages="cityErrors"
                                                label="Miasto"
                                                outlined
                                                dense
                                                :disabled="!isEditable || showOnly"
                                            />
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <v-select
                                                v-model="shippingLabelAddress.countryId"
                                                :error-messages="countryIdErrors"
                                                :items="countries"
                                                item-value="id"
                                                item-text="name"
                                                no-data-text="Nie znaleziono kraju"
                                                label="Kraj"
                                                outlined
                                                dense
                                                :disabled="!isEditable || showOnly"
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" sm="4">
                                            <v-datetime-picker
                                                ref="expeditionDateTimePicker"
                                                v-model="shippingLabelAddress.expeditionDateTime"
                                                label="Planowana data wysyłki"
                                                date-format="dd.MM.yyyy"
                                                :date-picker-props="dateTimeProps.dateProps"
                                                :text-field-props="dateTimeProps.textFieldProps"
                                                :time-picker-props="dateTimeProps.timeProps"
                                                :disabled="!isEditable || showOnly"
                                                @input="expeditionDateTimeHandler"
                                            >
                                                <template slot="dateIcon">
                                                    <v-icon>mdi-calendar</v-icon>
                                                </template>
                                                <template slot="timeIcon">
                                                    <v-icon>mdi-clock-outline</v-icon>
                                                </template>
                                                <template slot="actions" slot-scope="{parent}">
                                                    <v-btn text color="error" @click.native="parent.clearHandler">
                                                        Wyczyść
                                                    </v-btn>
                                                    <v-btn text color="success" @click="parent.okHandler">
                                                        Zapisz
                                                    </v-btn>
                                                </template>
                                            </v-datetime-picker>
                                        </v-col>
                                        <v-col cols="12" sm="4">
                                            <v-text-field
                                                v-model="shippingLabelAddress.phoneNumber"
                                                v-mask="'(+##) #########'"
                                                :error-messages="phoneNumberErrors"
                                                label="Telefon"
                                                outlined
                                                dense
                                                :disabled="!isEditable || showOnly"
                                            />
                                        </v-col>
                                    </v-row>
                                </div>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-card-text>
            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Zamknij"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    v-if="isEditable && !showOnly"
                    color="success"
                    text
                    :data-sentry-label="action ? 'Dodaj' : 'Zapisz'"
                    @click="onSave"
                >
                    <template v-if="action == 'create'">
                        Dodaj
                    </template>
                    <template v-else>
                        Zapisz
                    </template>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>

import parse from '@/mixins/parse.js'
import { required } from 'vuelidate/lib/validators'

export default {
    name: 'ShippingLabelAddressDialog',
    mixins: [ parse ],
    props: {
        isOpen: {
            type: Boolean,
        },
        isEditable: {
            type: Boolean,
        },
        action: {
            type: String,
            default: 'edit',
        },
        customer: {
            type: Object,
            default: () => {}
        },
        address: {
            type: Object,
            default: () => {}
        },
        senderAddresses: {
            type: Array,
            default: () => []
        },
        isReadyToPrint: {
            type: Boolean
        }
    },
    data() {
        return {
            senderAddress: {},
            shippingLabelAddress: {},
            customerAddress: null,
            customerPredictAddress: [],
            startDateTime: null,
            dateTimeProps: {
                textFieldProps: {
                    outlined: true,
                    dense: true,
                    prependIcon: 'mdi-calendar',
                    errorMessages: []
                },
                dateProps: {
                    firstDayOfWeek: 1
                },
                timeProps: {
                    format: '24hr',
                    scrollable: true
                }},
        }
    },
    computed: {
        showOnly() {
            return this.action === 'show'
        },
        countries() {
            return this.$store.state.customers.customers.countries
        },
        companyNameErrors() {
            const errors = []

            if (!this.$v.shippingLabelAddress.companyName.$dirty) return errors
            !this.$v.shippingLabelAddress.companyName.required && errors.push('Proszę podać nazwę firmy.')

            return errors
        },
        contactPersonErrors() {
            const errors = []

            if (!this.$v.shippingLabelAddress.contactPerson.$dirty) return errors
            !this.$v.shippingLabelAddress.contactPerson.required && errors.push('Proszę podać osobę do kontaktu.')

            return errors
        },
        streetErrors() {
            const errors = []

            if (!this.$v.shippingLabelAddress.street.$dirty) return errors
            !this.$v.shippingLabelAddress.street.required && errors.push('Proszę podać ulicę.')

            return errors
        },
        postCodeErrors() {
            const errors = []

            if (!this.$v.shippingLabelAddress.postCode.$dirty) return errors
            !this.$v.shippingLabelAddress.postCode.required && errors.push('Proszę podać kod pocztowy.')

            return errors
        },
        cityErrors() {
            const errors = []

            if (!this.$v.shippingLabelAddress.city.$dirty) return errors
            !this.$v.shippingLabelAddress.city.required && errors.push('Proszę podać miasto.')

            return errors

        },
        countryIdErrors() {
            const errors = []

            if (!this.$v.shippingLabelAddress.countryId.$dirty) return errors
            !this.$v.shippingLabelAddress.countryId.required && errors.push('Proszę wybrać kraj.')

            return errors
        },
        expeditionDateTimeErrors() {
            const errors = []

            if (!this.$v.shippingLabelAddress.expeditionDateTime.$dirty) return errors

            !this.$v.shippingLabelAddress.expeditionDateTime.required && this.updateErrorMessages('Proszę podać planowaną datę wysyłki.')

            return errors
        },
        phoneNumberErrors() {
            const errors = []

            if (!this.$v.shippingLabelAddress.phoneNumber.$dirty) return errors
            !this.$v.shippingLabelAddress.phoneNumber.required && errors.push('Proszę podać numer telefonu.')

            return errors
        },
        senderCompanyNameErrors() {
            const errors = []

            if (!this.$v.shippingLabelAddress.senderCompanyName.$dirty) return errors
            !this.$v.shippingLabelAddress.senderCompanyName.required && errors.push('Proszę podać nazwę firmy.')

            return errors
        },
        senderStreetErrors() {
            const errors = []

            if (!this.$v.shippingLabelAddress.senderStreet.$dirty) return errors
            !this.$v.shippingLabelAddress.senderStreet.required && errors.push('Proszę podać ulicę.')

            return errors
        },
        senderZipCodeErrors() {
            const errors = []

            if (!this.$v.shippingLabelAddress.senderZipCode.$dirty) return errors
            !this.$v.shippingLabelAddress.senderZipCode.required && errors.push('Proszę podać kod pocztowy.')

            return errors
        },
        senderCityErrors() {
            const errors = []

            if (!this.$v.shippingLabelAddress.senderCity.$dirty) return errors
            !this.$v.shippingLabelAddress.senderCity.required && errors.push('Proszę podać miasto.')

            return errors
        },
    },
    watch: {
        isOpen(value) {
            if (value && this.customer?.id) {
                this.setInitial({
                    ...this.address,
                    expeditionDateTime: this.address?.expeditionDateTime
                        ? new Date(this.address.expeditionDateTime)
                        : null,
                })
                !this.countries.length && this.$store.dispatch('customers/getCountries')

                this.$store.dispatch('customers/getCustomerAddresses', this.customer.id)
                    .then(({ data }) => {
                        this.customerPredictAddress = data.results
                    })
            }
        }
    },
    validations() {
        return {
            shippingLabelAddress: {
                companyName: {
                    required
                },
                contactPerson: {
                    required
                },
                street: {
                    required
                },
                postCode: {
                    required
                },
                city: {
                    required
                },
                countryId: {
                    required
                },
                expeditionDateTime: {
                    required
                },
                phoneNumber: {
                    required
                },
                senderCompanyName: {
                    required
                },
                senderStreet: {
                    required
                },
                senderZipCode: {
                    required
                },
                senderCity: {
                    required
                }
            }
        }
    },
    methods: {
        expeditionDateTimeHandler(date) {
            date ? this.dateTimeProps.textFieldProps.errorMessages = [] :
                this.dateTimeProps.textFieldProps.errorMessages.push('Proszę podać planowaną datę wysyłki.')

        },
        updateErrorMessages(errorMessage) {
            this.dateTimeProps.textFieldProps.errorMessages = []

            return this.dateTimeProps.textFieldProps.errorMessages.push(errorMessage)
        },
        changeAddress(address) {
            if (!address) { return }

            this.shippingLabelAddress = {
                ...this.shippingLabelAddress,
                country: address.country,
                countryId: address.countryId,
                postCode: address.postCode,
                street: address.street,
                companyName: address.companyName,
                city: address.city,
            }

            const contact = address.contacts.length ? address.contacts[0] : null

            if (contact) {
                this.shippingLabelAddress = {
                    ...this.shippingLabelAddress,
                    phoneNumber: contact.phoneNumber,
                    contactPerson: `${contact.firstName} ${contact.lastName}`.trim(),
                }
            }

        },
        changeSenderAddress(address) {
            if (!address) { return }

            this.shippingLabelAddress = {
                ...this.shippingLabelAddress,
                senderCountry: address.country,
                senderCountryId: address.countryId,
                senderZipCode: address.zipCode,
                senderStreet: address.street,
                senderCompanyName: address.companyName,
                senderCity: address.city,
                senderPhoneNumber: address.phoneNumber,
                senderLastName: address.lastName,
                senderFirstName: address.firstName
            }
        },
        setInitial(value = {
            companyName: null,
            contactPerson: null,
            street: null,
            postCode: null,
            city: null,
            countryId: null,
            country: null,
            expeditionDateTime: null,
            phoneNumber: null,
            senderCountry: null,
            senderCountryId: null,
            senderZipCode: null,
            senderStreet: null,
            senderCompanyName: null,
            senderCity: null,
            senderPhoneNumber: null,
            senderFirstName: null,
            senderLastName: null
        }) {
            this.shippingLabelAddress = value
        },
        onSave() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })
                this.expeditionDateTimeHandler(this.shippingLabelAddress.expeditionDateTime)

                return
            }

            this.$emit('on-save', {
                ...this.shippingLabelAddress,
                expeditionDateTime: this.shippingLabelAddress && this.shippingLabelAddress.expeditionDateTime
                    ? this.shippingLabelAddress.expeditionDateTime?.toISOString()
                    : null,
            })
            this.onClose()
        },
        onClose() {
            this.$emit('on-close')
            setTimeout(() => {
                this.setInitial()
                this.$refs.expeditionDateTimePicker?.clearHandler()
                this.$v.$reset()
                this.dateTimeProps.textFieldProps.errorMessages = []
                this.senderAddress = {}
                this.customerAddress = {}
            }, 200)

        }
    },
}
</script>